import { CourseDay } from './course-day';

export class Course {
  Id: number;
  Date: Date;
  Code: string;
  Name: string;
  Region: string;
  Price: number;
  Duration: number;
  DurationType: string;
  DurationInfo: string;
  AvailableSeats: number;
  IsFull: boolean;
  CourseDays: CourseDay[];
  TemplateId: number;
  RegionId: string;
  IsOngoing: boolean;
  UserField1: string;
  UserField2: string;
  UserField3: string;
  UserField4: string;
  UserField5: string;
  UserField6: string;
  UserField7: string;
  UserField8: string;
  UserField9: string;
}
